import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import actions from '../actions';

const CLASS_NAME = 'slx-product-wizard-result-item';

export default createReactClass({
	displayName: 'ProductWizardResultItem',

	propTypes: {
		item: PropTypes.object.isRequired,
		id: PropTypes.number,
		compositions: PropTypes.array
	},

	getInitialState() {
		return {active: false};
	},

	showSheet() {
		actions.showSheet(this.props.item);
	},

	render() {
		const id = `${CLASS_NAME}-${this.props.id}`;
		const thClass = `${CLASS_NAME}__th`;
		const compositionLeft = (this.props.compositions && this.props.compositions[0] && this.props.item.compositions[this.props.compositions[0]]) || '';
		const compositionRight = (this.props.compositions && this.props.compositions[1] && this.props.item.compositions[this.props.compositions[1]]) || '';

		const headline = (
			<div className={`${CLASS_NAME}__headline`} onClick={this.showSheet}>
				<span className={`${CLASS_NAME}__left`}>
					<span className={`${thClass} ${thClass}--serial`}>{this.props.item.number}</span>
					<span className={`${thClass} ${thClass}--label`} dangerouslySetInnerHTML={{__html: compositionLeft}}></span>
				</span>
				<span className={`${CLASS_NAME}__right`}>
					<span className={`${thClass} ${thClass}--price`} dangerouslySetInnerHTML={{__html: compositionRight}}></span>
				</span>
			</div>
		);

		return (
			<li className={CLASS_NAME}>
				{headline}
			</li>
		);
	}
});
